import router from '../../components/routing/router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { useEffect } from 'react';
import moment from 'moment';
import { getNotificationData, selectNotifications, selectIsLoading, selectError, Notification } from '../../reducers/notificationSlice';
import { useAppDispatch, useAppSelector } from '../../reducers/store';

export function NotificationModal() {
    const dispatch = useAppDispatch();
    const notifications = useAppSelector(selectNotifications);
    const isLoading = useAppSelector(selectIsLoading);
    const error = useAppSelector(selectError);

    //let notifications:any[] = [];
    //let unReadNotifications = 0;

    // const [unReadNotifications, setUnReadNotifications] = useState(0);

    // const processNav = (path: string) => {
    //     router.navigate(path)
    // }

    useEffect(() => {
        const getNotifcations = async () => {
            await dispatch(getNotificationData());
        }

        getNotifcations();
    }, [dispatch]);

    function formatDate(date: string){
        return moment(date).format('MMMM D, YYYY [at] h:mm a')
    }

    if (isLoading) {
        return (
            <div className="w-[800px] h-[80%] bg-[#ffffff] z-99 shadow-xl border-4 border-[#ffd60a] rounded-3xl">
                <div className='text-center'>
                    <h1 className='text-[25px] font-light py-[15px] text-[#666666]'>Loading notifications...</h1>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="w-[800px] h-[80%] bg-[#ffffff] z-99 shadow-xl border-4 border-[#ffd60a] rounded-3xl">
                <div className='text-center'>
                    <h1 className='text-[25px] font-light py-[15px] text-[#666666]'>Error loading notifications</h1>
                </div>
            </div>
        );
    }

    return (
        <div className="w-[800px] h-[80%] bg-[#ffffff] z-99 shadow-xl border-4 border-[#ffd60a] rounded-3xl">
           <div className='text-center'>
                <h1 className='text-[25px] font-light py-[15px] text-[#666666]'>Notifications</h1>
           </div>
           <div className='overflow-scroll max-h-[90%]'>
            {notifications.map((notification: Notification, index: number) => (
                <div key={index} className='flex items-center px-[15px] py-[25px]'>
                    <div className='w-[10%]'>{notification.acknowledged && <FontAwesomeIcon icon={faCircle} className='text-[25px] text-[#ffd60a]' />} </div>
                    <div className='w-[90%] text-[#000000]'>
                        <b>{notification.message}</b>
                        <p>{formatDate(notification.createTime)}</p>
                    </div>
                </div>
            ))}
           </div>
        </div>
    );
}
